import React, { Component } from 'react';
import LoginPs from './LoginPs';
import LoginUd from './LoginUd';
import { isEmail } from 'validator';
import $ from 'jquery';

class LoginCt extends Component {
  constructor(props) {
    super(props);
    //箭頭函數會綁定this代表的物件為其被定義當下所處位置的this指向的物件
    this.handlers = {
      handlePassword: () => {
        this.setState({
          showPassword: !this.state.showPassword
        });
      },
      handleRemEmail: () => {
        this.setState({
          remEmail: !this.state.remEmail
        });
      },
      //將輸入內容納入控制
      handleEmailKeyin: e => {
        const value = e.target.value.substr(0, 50);
        if (isEmail(value)) {
          this.setState({
            email: value,
            disableLoginBtn: false
          });
        } else {
          this.setState({
            email: value,
            disableLoginBtn: true //過程中可能再次invalid
          });
        }
      },
      handlePasswordKeyin: e => {
        this.setState({
          password: e.target.value.substr(0, 32)
        });
      },
      handleCapchaKeyin: e => {
        this.setState({
          capcha: e.target.value.substr(0, 10) //透過狀態控制render以限制內容長度
        });
      },
      handleSubmit: e => {
        const postData = {
          user_account: this.state.email,
          user_passwd: this.state.password,
          pic_num: this.state.capcha
        };
        //選擇不記錄時，不論是否正確都應清除
        if (!this.state.remEmail) localStorage.removeItem('email');
        //for 輸入結果回饋效果
        if (this.state.showErrMsg === true) this.setState({ showErrMsg: false });

        $.ajax({
          type: 'POST',
          url: '/api/W_Login.php',
          data: postData,
          dataType: 'json',
          success: data => {
            if (data.status === '0') {
              // 登入成功
              // 選擇記錄時，正確才有記錄的必要
              if (this.state.remEmail) localStorage.email = this.state.email;
              // 登入狀態記錄
              let res = data.result;
              this.props.stateHandler(
                [
                  'isLogin', 'userName', 'userId', 'groupId', 'userPhotoSrc',
                  'isAdmin', 'userPermission', 'systemEnvironment', 'language', 'isSuperAdmin'
                ],
                [
                  true, res.name, res.user_id, res.user_group, res.photo,
                  res.is_admin, res.permission, res.system_environment, 'en-us', res.is_super_admin
                ]
              );

              sessionStorage.isLogin = true;
              sessionStorage.userName = res.name;
              sessionStorage.userId = res.user_id;
              sessionStorage.groupId = res.user_group;
              sessionStorage.userPhotoSrc = res.photo;
              sessionStorage.isAdmin = res.is_admin;
              sessionStorage.isSuperAdmin = res.is_super_admin;
              sessionStorage.userPermission = JSON.stringify(res.permission);
              sessionStorage.systemEnvironment = JSON.stringify(res.system_environment);
              // 公司資訊
              sessionStorage.companyTitle = res.corp_name;
              sessionStorage.companyLogo = res.corp_logo_path;
              sessionStorage.companyTel = res.corp_tel;
              sessionStorage.companyFax = res.corp_fax;
              sessionStorage.companyAddress = res.corp_address;
              sessionStorage.companyEmail = res.corp_email;
              // 語言
              localStorage.language = 'en-us';
              // 使用App元件的routehandler
              this.props.routeHandler('/salesky/news', 'replace'); // skyfamily架構應導向 '/'
            } else {
              let errMsg;

              switch (data.status) {
                case 501:
                  errMsg = '驗證碼錯誤，請更正。';
                  // 透過capchaImgSrc更新capcha
                  this.resetCapcha();
                  break;
                case 400:
                  errMsg = '驗證碼已過期，請重取驗證碼。';
                  break;
                case '-1':
                case '-4':
                  errMsg = '帳號或密碼錯誤，請更正。';
                  break;
                default:
                  errMsg = '請聯繫系統管理員。';
              }

              this.setState({
                errMsg: errMsg,
                showErrMsg: true
              });
            }
          },
          error: (xhr, status, error) => {
            this.setState({
              errMsg: '伺服器連線異常，請檢查您的設定'
            });
          }
        });
      }
    };

    this.resetCapcha = () => {
      this.setState({
        capchaImgSrc: `/api/AuthCode.php?${Math.floor((Math.random() * 100) + 1)}`
      });
    };

    // initial state
    this.state = {
      showPassword: false,
      remEmail: localStorage.email ? true : false,
      email: localStorage.email || '', // 前者true則傳回前者，否則傳回後者，避免傳入undefine給受控的input的value
      password: '',
      disableLoginBtn: !localStorage.email || false, // 注意前方的'!'
      capcha: '',
      capchaImgSrc: '/api/AuthCode.php',
      errMsg: '',
      showErrMsg: false
    };
  }

  componentDidMount() {
    let focus = localStorage.email ? 'fcPw' : 'fcEm';
    document.getElementById(focus).focus();

    let btnLogin = $('#btnLogin');
    // 元素是參照到dom，所以屬性改變能關聯到，
    // 要注意的是元素更新的情況，存到變數中的元素可能不是更新後的

    $('#fcPw, #fcEm, #inpCapcha').keyup(e => {
      if (e.keyCode === 13 && !btnLogin.attr('disabled')) this.handlers.handleSubmit();
    });
  }

  render() {
    const
      outLocation = (location.port === '' || location.port === '80' || location.port === '443')
        ? `${location.protocol}//${location.hostname}`
        : `${location.protocol}//${location.hostname}:${location.port}`;

    return (
      <div id='div-login-ct'>
        <div className='div-login-content-container'>
          <div className='div-login-left-side'>
            <img src='./imgs/logo_skyfamily.svg' alt='logo' />
            <p>
              行動業務雲端解決方案，讓製造業藉由行動以及雲端科技的<br />
              整合，大幅度改善經營管理效能，提升企業的國際競爭力。
            </p>
            <p>
              ．系統效益 :<br />
              快速滿足客戶需求<br />
              經營績效的即時掌握
            </p>
            <a href={outLocation} target='_blank'>{outLocation}</a>
          </div>
          <div className='div-login-right-side'>
            <LoginPs errMsg={this.state.errMsg} showErrMsg={this.state.showErrMsg} />
            <LoginUd showPassword={this.state.showPassword}
              email={this.state.email}
              remEmail={this.state.remEmail}
              password={this.state.password}
              handlers={this.handlers}
              disabled={this.state.disableLoginBtn}
              capchaImgSrc={this.state.capchaImgSrc}
              capcha={this.state.capcha}
              resetCapcha={this.resetCapcha} />
          </div>
        </div>
        <span id='span-copyright-login'></span>
      </div>
    );
  }
}

export default LoginCt;



// WEBPACK FOOTER //
// ./src/skyfamily/routes/login/LoginCt.jsx